import styled from "styled-components"
import theme from "styles/theme-main"

export const PhoneNumberWrapper = styled.div`
  position: relative;
  max-width: 454px;

  & .PhoneInputInput {
    max-width: 408px;
    color: #323c44;
    font-weight: bold;
    border: 0;
    border-bottom: 1px solid #c4cace;
    height: 34px;
    padding-left: 7px;
  }

  & .PhoneInputInput:focus {
    outline: none;
    border-bottom: 2px solid ${theme.colors.primary};
  }

  & .PhoneInputInput::placeholder {
    color: #808b95;
    font-weight: normal;
  }
`

export const Label = styled.span`
  color: ${theme.colors.textSecondary} !important;
  font-size: 12px;
  padding-left: 11px;
`

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: right;
  align-content: center;
  position: absolute;
  top: 0;
  left: 40px;
  height: 47.4px;
  color: ${theme.colors.danger} !important;
  font-size: 12px;
  padding-left: 11px;
  margin-right: 12px;
  margin-top: 5px;
  border-bottom: 2px solid ${theme.colors.danger};
  width: 408px;
  pointer-events: none;
`

export const ErrorMessage = styled.div`
  display: flex;
  font-size: 14px;
  margin-top: 22px;
`

export const FormIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-left: 9px;
  color: ${props =>
    props.variant === "success" ? theme.colors.success : theme.colors.danger};
`
